<clr-combobox-container
  [style]="safeContainerStyle"
  [class.subs-horizontal]="horizontal"
>
  <label
    *ngIf="label !== 'hideLabel'"
    [class.clr-col-12]="!horizontal"
    class="clr-col-md-auto"
    [style]="safeLabelStyle"
  >
    {{ label }}
  </label>
  <clr-combobox
    [class.clr-col-12]="!horizontal"
    class="clr-col-md"
    [attr.data-test-id]="controlName"
    [formControlName]="controlName"
    clrMulti="true"
  >
    <ng-container *clrOptionSelected="let selected">
      {{ getOptionLabel(selected) }}
    </ng-container>

    <clr-options>
      <clr-option
        *clrOptionItems="let option of options; field: 'label'"
        [clrValue]="option.value"
      >
        {{ option.label }}
      </clr-option>
    </clr-options>
  </clr-combobox>

  <clr-control-error>
    {{ errorMessage }}
  </clr-control-error>
</clr-combobox-container>
